import { render, staticRenderFns } from "./savedReport.vue?vue&type=template&id=128da5ec&scoped=true&"
import script from "./savedReport.vue?vue&type=script&lang=js&"
export * from "./savedReport.vue?vue&type=script&lang=js&"
import style0 from "./savedReport.vue?vue&type=style&index=0&id=128da5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128da5ec",
  null
  
)

export default component.exports